if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-items');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.giftCardCheckbox = document.querySelector('#pdp_giftCard_checkbox');
        this.giftCardSelectTrigger = document.querySelector('.custom-giftcard-select__trigger span');
        this.giftCardNote = document.querySelector('#pdp-giftCard-note');
        this.template = this.dataset.template;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (!this.variantIdInput.value) {
          this.handleErrorMessage('Please select a variant');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            // Add gift packaging or card product if enabled
            let giftResponse = null;
            if (this.giftCardCheckbox?.checked && this.giftCardSelectTrigger) {
              if (this.giftCardNote?.value && this.giftCardNote?.value.length > 0) await this.updateNote(this.giftCardNote?.value);

              giftResponse = await this.addGiftProductIfEnabled();
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(async () => {
                    const shippingProtection = document.querySelector('cart-shipping-protection');
                    shippingProtection?.updateCartTotal(response);
                    const shippingProtectionData = await shippingProtection?.updateShippingProtection();

                    this.cart.renderContents(shippingProtectionData ?? giftResponse ?? response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              const shippingProtection = document.querySelector('cart-shipping-protection');
              shippingProtection?.updateCartTotal(response);
              const shippingProtectionData = await shippingProtection?.updateShippingProtection();

              this.cart.renderContents(shippingProtectionData ?? giftResponse ?? response);
            }

            // update social proof count
            await window.updateSocialCount(response.product_id);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async addGiftProductIfEnabled() {
        try {
          const giftCardProductId = this.giftCardSelectTrigger.getAttribute('product-id');
          if (!giftCardProductId) return;

          const properties = {
            'Gift Note': this.giftCardNote?.value || '',
          }

          const body = JSON.stringify({
            id: giftCardProductId,
            quantity: 1,
            properties,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          });

          const response = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })

          if (!response.ok) {
            const errorText = await response.text();
            console.error('Error adding gift card product:', errorText);
            return;
          }

          const responseJson = await response.json();

          const giftPacking = document.querySelector('gift-package');
          giftPacking?.hide();

          this.giftCardCheckbox.checked = false;

          return responseJson;
        } catch (error) {
          console.error('Error adding gift card product:', error);
        }
      }

      async updateNote(note) {
        const body = JSON.stringify({ note: note });
        await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          //this.submitButton.classList.add('hidden');
          if (text) {
            this.submitButtonText.textContent = text;
            this.submitButton.classList.add('hidden');
          } 
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.classList.remove('hidden');
          this.submitButtonText.textContent = this.template == "giftcard" ? window.variantStrings.send_to_me :window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
